(function () {
  'use strict';
  if (window.__chagualPlanterSpecs) return;
  window.__chagualPlanterSpecs = true;

  // Only typography is normalized: no product-name, option-position or fuzzy guesses.
  function sizeKey(value) {
    var text = String(value || '').trim().toLowerCase();
    text = text.replace(/\s*\((?:diám\.?|diámetro|ancho|largo)\s*[x×]\s*(?:ancho\s*[x×]\s*)?alto\)$/, '');
    if (!/^\d+(?:[.,]\d+)?(?:\s*[x×]\s*\d+(?:[.,]\d+)?){1,2}\s*(?:cm)?$/.test(text)) return null;
    return text.replace(/cm$/, '').replace(/\s/g, '').replace(/×/g, 'x').replace(/,/g, '.');
  }

  function inlineContent(node) {
    return Array.prototype.every.call(node.querySelectorAll('*'), function (child) {
      return /^(BR|STRONG|B|EM|I|SPAN)$/.test(child.tagName);
    });
  }

  function factsText(node) {
    var copy = node.cloneNode(true);
    copy.querySelectorAll('br').forEach(function (line) { line.replaceWith(document.createTextNode('\n')); });
    return copy.textContent.trim().replace(/^\((?:diám\.?|diámetro|ancho|largo)\s*[x×]\s*(?:ancho\s*[x×]\s*)?alto\)\s*/i, '');
  }

  function isFactList(node) {
    if (!inlineContent(node)) return false;
    var text = factsText(node);
    if (!text) return true;
    return text.split(/[·•;\n]+/).filter(function (fact) { return fact.trim(); }).every(function (fact) {
      return /^(?:(?:boca(?: útil)?|base|peso|capacidad|volumen|altura|alto|ancho|largo|diámetro)\s*:?\s*(?:aprox(?:imad[oa])?\.?\s*)?\d+(?:[.,]\d+)?(?:\s*[x×]\s*\d+(?:[.,]\d+)?){0,2}\s*(?:cm|mm|kg|litros?|lt|l)|\d+(?:[.,]\d+)?\s*kg)$/i.test(fact.trim());
    });
  }

  function generalNote(node) {
    return /^(P|DIV)$/.test(node.tagName) && inlineContent(node) &&
      /^\*?\s*(?:las\s+)?(?:medidas|dimensiones)\s+(?:publicadas\s+)?(?:corresponden|pueden|son|exteriores)\b/i.test(node.textContent.trim());
  }

  function labelWeight(node) {
    var textNodes = document.createTreeWalker(node, 4);
    while (textNodes.nextNode()) {
      textNodes.currentNode.textContent = textNodes.currentNode.textContent.replace(/(^|[·•;\n])(\s*)(\d+(?:[.,]\d+)?\s*kg)(?=\s*(?:[·•;\n]|$))/gi, '$1$2Peso $3');
    }
  }

  function normalizeLegacy(root) {
    var legacy = root.querySelector('[data-planter-legacy-content]');
    if (!legacy) return true;
    var container = legacy.querySelector('.metafield-rich_text_field') || legacy;
    var prepared = container.cloneNode(true), current = null, rowCount = 0;
    var children = Array.prototype.slice.call(prepared.childNodes);
    // Build a complete candidate off-DOM. Any unclassified residue leaves the
    // original parsed DOM unchanged and disables all physical-size filtering.
    for (var index = 0; index < children.length; index += 1) {
      var node = children[index];
      if (node.nodeType === 3 && !node.textContent.trim()) continue;
      if (node.nodeType !== 1 || !/^(P|DIV|H[1-6])$/.test(node.tagName)) return false;
      if (!node.textContent.trim()) { current = null; continue; }
      var title = /^H[1-6]$/.test(node.tagName) ? node : node.firstElementChild;
      var directTitle = title && (title === node || /^(STRONG|B)$/.test(title.tagName));
      var leading = Boolean(title);
      if (title && title !== node) {
        for (var before = node.firstChild; before && before !== title; before = before.nextSibling) {
          if (before.nodeType !== 3 || before.textContent.trim()) { leading = false; break; }
        }
      }
      if (directTitle && leading && sizeKey(title.textContent)) {
        if (!inlineContent(node)) return false;
        var body = document.createElement('div');
        body.className = 'ua-size-meta';
        if (title !== node) {
          var copy = node.cloneNode(true);
          copy.firstElementChild.remove();
          if (!isFactList(copy)) return false;
          while (copy.firstChild && (copy.firstChild.nodeName === 'BR' || !copy.firstChild.textContent.trim())) copy.firstChild.remove();
          if (copy.textContent.trim()) { labelWeight(copy); body.appendChild(copy); }
        }
        var row = document.createElement('div');
        row.className = 'ua-size-row';
        row.setAttribute('data-planter-size-row', '');
        row.setAttribute('data-planter-size', title.textContent.trim());
        var heading = document.createElement('div');
        heading.className = 'ua-size-title';
        var label = document.createElement('span');
        label.className = 'ch-planter-specs__label';
        label.textContent = 'Medidas exteriores';
        heading.appendChild(label);
        heading.appendChild(document.createTextNode(title.textContent.trim()));
        row.appendChild(heading);
        row.appendChild(body);
        node.replaceWith(row);
        current = body;
        rowCount += 1;
      } else if (generalNote(node)) {
        current = null;
      } else if (current && /^(P|DIV)$/.test(node.tagName) && isFactList(node)) {
        labelWeight(node);
        current.appendChild(node);
      } else {
        return false;
      }
    }
    if (!rowCount) return false;
    container.replaceChildren.apply(container, Array.prototype.slice.call(prepared.childNodes));
    return true;
  }

  function init(root) {
    if (root.dataset.planterSpecsReady) return;
    root.dataset.planterSpecsReady = 'true';
    var physicalFilterable = normalizeLegacy(root);
    var section = root.closest('.js-product-section');
    var payload = root.querySelector('[data-planter-variants]');
    var select = section && section.querySelector('select[name="id"][data-variants]');
    if (!payload || !select) return;
    var data;
    try { data = JSON.parse(payload.textContent); } catch (error) { return; }
    if (!Array.isArray(data.options) || !Array.isArray(data.variants)) return;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-planter-size-row]'));
    var capacities = Array.prototype.slice.call(root.querySelectorAll('[data-canonical-variant-id]'));
    var capacityGroup = root.querySelector('[data-planter-capacities]');
    var context = root.querySelector('[data-planter-size-context]');
    var sizeOptions = data.options.filter(function (option) {
      return Number.isInteger(option.position) && option.position > 0 && Array.isArray(option.values) && option.values.length > 0 && option.values.every(function (value) { return sizeKey(value) !== null; });
    });
    var sizeOption = sizeOptions.length === 1 ? sizeOptions[0] : null;
    window.__chagualPlanterSpecsSequence = (window.__chagualPlanterSpecsSequence || 0) + 1;
    root.id = 'ch-planter-specs-' + window.__chagualPlanterSpecsSequence;
    if (context) context.id = root.id + '-context';
    var linkedControls = [select];
    if (sizeOption) {
      section.querySelectorAll('.swatch_options .swatch[data-option-index]').forEach(function (group) {
        if (Number(group.getAttribute('data-option-index')) === sizeOption.position - 1) {
          Array.prototype.push.apply(linkedControls, group.querySelectorAll('input[type="radio"]'));
        }
      });
    }
    linkedControls.forEach(function (control) {
      ['aria-controls', 'aria-describedby'].forEach(function (attribute) {
        var target = attribute === 'aria-controls' ? root.id : context && context.id;
        if (!target) return;
        var values = (control.getAttribute(attribute) || '').split(/\s+/).filter(Boolean);
        if (values.indexOf(target) === -1) values.push(target);
        control.setAttribute(attribute, values.join(' '));
      });
    });

    function showAll() {
      rows.concat(capacities).forEach(function (row) { row.hidden = false; });
      if (capacityGroup) capacityGroup.hidden = false;
      if (context) context.textContent = 'Medidas por tamaño';
    }

    function sync() {
      showAll();
      var variants = data.variants.filter(function (variant) { return String(variant.id) === String(select.value); });
      if (variants.length !== 1) return;
      var variant = variants[0];
      // Wait until the visible selectors agree with the actual selected variant.
      var controls = section.querySelectorAll('.swatch_options .swatch[data-option-index]');
      for (var index = 0; index < controls.length; index += 1) {
        var checked = controls[index].querySelector('input[type="radio"]:checked');
        var position = Number(controls[index].getAttribute('data-option-index'));
        if (!checked || !Array.isArray(variant.options) || variant.options[position] !== checked.value) return;
      }
      capacities.forEach(function (row) { row.hidden = row.getAttribute('data-canonical-variant-id') !== String(variant.id); });
      if (capacityGroup) capacityGroup.hidden = capacities.every(function (row) { return row.hidden; });
      if (!physicalFilterable || !sizeOption || !Array.isArray(variant.options) || !rows.length) return;
      var value = variant.options[sizeOption.position - 1];
      if (sizeOption.values.indexOf(value) === -1) return;
      var key = sizeKey(value);
      var rowKeys = rows.map(function (row) { return sizeKey(row.getAttribute('data-planter-size')); });
      if (rowKeys.some(function (rowKey) { return rowKey === null || rowKeys.indexOf(rowKey) !== rowKeys.lastIndexOf(rowKey); })) return;
      var optionKeys = sizeOption.values.map(sizeKey);
      if (rowKeys.length !== optionKeys.length || optionKeys.some(function (optionKey) { return rowKeys.indexOf(optionKey) === -1; })) return;
      var optionMatches = sizeOption.values.filter(function (candidate) { return sizeKey(candidate) === key; });
      var rowMatches = rows.filter(function (row) { return sizeKey(row.getAttribute('data-planter-size')) === key; });
      if (optionMatches.length !== 1 || rowMatches.length !== 1) return;
      rows.forEach(function (row) { row.hidden = row !== rowMatches[0]; });
      if (context) context.textContent = 'Tamaño seleccionado: ' + value;
      // A legacy volume is kept as written. Suppress a duplicate canonical capacity
      // only when this exact selected size states the same numeric quantity in litres.
      var statedCapacity = rowMatches[0].textContent.match(/(?:volumen|capacidad)\s*:?\s*(\d+(?:[.,]\d+)?)\s*(?:litros?|lt|l)\b/i);
      capacities.forEach(function (row) {
          if (row.hidden) return;
          var capacity = row.querySelector('.ua-size-value');
          if (!capacity) { row.hidden = true; return; }
          var canonicalCapacity = capacity && capacity.textContent.trim().match(/^(\d+(?:[.,]\d+)?)\s*(?:litros?|lt|l)$/i);
          if (statedCapacity && canonicalCapacity && Number(canonicalCapacity[1].replace(',', '.')) === Number(statedCapacity[1].replace(',', '.'))) row.hidden = true;
      });
      if (capacityGroup) capacityGroup.hidden = capacities.every(function (row) { return row.hidden; });
    }

    var frame = null;
    function schedule(event) {
      if (!event.target.matches('select[name="id"][data-variants], .swatch_options input[type="radio"]')) return;
      showAll();
      if (frame !== null) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        frame = window.requestAnimationFrame(function () { frame = null; sync(); });
      });
    }
    section.addEventListener('change', schedule);
    function unload(event) {
      if (event.target !== section && !event.target.contains(section)) return;
      section.removeEventListener('change', schedule);
      if (frame !== null) window.cancelAnimationFrame(frame);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    sync();
  }

  function boot(scope) {
    scope.querySelectorAll('[data-planter-measures]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
}());
